import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import { smsTemplateAdminContext } from "../../../context/Admin/SMSTemplateAdminContext/SMSTemplateAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const SMSTemplateAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    smsTemplateItems,
    smsTemplate,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    id,
    title,
    setTitle,
    message,
    setMessage,
    description,
    setDescription,
    isShowModal,
    isShowDetailsModal,
    setIsShowDetailsModal,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetSMSTemplateItemList,
    handleCreateSMSTemplateItem,
    handleEditSMSTemplateItem,
    handleDeleteSMSTemplateItem,
  } = useContext(smsTemplateAdminContext);

  useEffect(() => {
    handleGetSMSTemplateItemList();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="آیتم های قالب پیامکی" />

      <CardLayout>
        {permission.sms_messages_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(smsTemplateItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>عنوان</th>
                  <th>توضیحات</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {smsTemplateItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{_item.title}</td>
                    <td>{_item.description}</td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.sms_messages_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.sms_messages_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteSMSTemplateItem(_item.id),
                              `آیا از حذف آیتم قالب پیامکی ${_item.id} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} آیتم قالب پیامکی`}
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={
            id ? handleEditSMSTemplateItem : handleCreateSMSTemplateItem
          }
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="title">عنوان</label>
              <input
                type="text"
                id="title"
                name="title"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="message">متن پیامک</label>
              <textarea
                id="message"
                name="message"
                className="form-control"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={7}
              />
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم قالب پیامکی"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{smsTemplate.id}</p>
            </ItemInfo>
            <ItemInfo label="عنوان">
              <p>{smsTemplate.title}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{smsTemplate.description}</p>
            </ItemInfo>
            <ItemInfo label="متن پیامک">
              <p className="pre_wrap-white_space">{smsTemplate.message}</p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default SMSTemplateAdmin;
